module.exports = __webpack_public_path__ + "static/media/shop.56c34fd8.png";